import { apiFetch } from "../api";
import { BASE_URL } from "../../commonUrls";

const BASE = `${BASE_URL}/push`;

/** Convert a base64url VAPID public key to a Uint8Array for the browser API. */
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function getVapidPublicKey() {
  const res = await apiFetch(`${BASE}/vapid-public-key`);
  if (!res.ok) return null;
  const data = await res.json();
  return data.publicKey || null;
}

export async function subscribeToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push not supported in this browser");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission denied");

  const vapidKey = await getVapidPublicKey();
  if (!vapidKey || vapidKey.includes("REPLACE")) {
    throw new Error("VAPID keys not configured on server — run: npx web-push generate-vapid-keys");
  }

  const reg = await navigator.serviceWorker.ready;
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidKey),
  });

  const json = subscription.toJSON();
  const res = await apiFetch(`${BASE}/subscribe`, {
    method: "POST",
    body: JSON.stringify({
      endpoint: json.endpoint,
      keys: json.keys,
      userAgent: navigator.userAgent,
    }),
  });
  if (!res.ok) throw new Error("Failed to save subscription on server");
  return subscription;
}

export async function unsubscribeFromPush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await apiFetch(`${BASE}/unsubscribe`, {
    method: "DELETE",
    body: JSON.stringify({ endpoint: sub.endpoint }),
  });
  await sub.unsubscribe();
}

export async function isPushSubscribed() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return sub !== null;
  } catch { return false; }
}

export async function sendTestPush() {
  return apiFetch(`${BASE}/test`, { method: "POST" });
}
